// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"876d9301","453":"2d087325","455":"88fc0a77","977":"218fef8b"}[chunkId] + ".chunk.js";
};